import { render, staticRenderFns } from "./templateList.vue?vue&type=template&id=1a0e97a5&scoped=true"
import script from "./templateList.vue?vue&type=script&lang=js"
export * from "./templateList.vue?vue&type=script&lang=js"
import style0 from "./templateList.vue?vue&type=style&index=0&id=1a0e97a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0e97a5",
  null
  
)

export default component.exports